import React, { useEffect, useRef, useState } from "react";
import "./view.scss";
import { TagVideoList } from "../../component/video/TagVideoList";
export function linkifyText(text) {
  if(!text){
    return ""
  }
  const urlRegex =
    /\bhttps?:\/\/[^\s/$.?#].[^\s]*|\b(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?/gi;

  const parts = text.split(urlRegex);

  const matches = text.match(urlRegex) || [];

  const result = [];
  let i = 0;

  parts.forEach((part, index) => {
    result.push(part);
    if (index < matches.length) {
      let href = matches[i];
      if (!href.startsWith("http")) {
        href = "http://" + href;
      }
      result.push(
        <a
          key={`link-${i}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "blue" }}
        >
          {matches[i]}
        </a>
      );
      i++;
    }
  });

  return result;
}
const options = {
  target: "_blank",
  rel: "noopener noreferrer",
  nl2br: false,
  formatHref: {
    url: (href) => href,
  },
  ignoreTags: ["script", "style"],
};

const VideoDescription = ({ text ,offices = [],tags=[],categoryName,description,listMachine=[]}) => {
  const [expanded, setExpanded] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const contentRef = useRef();

  useEffect(() => {
    if (contentRef.current.scrollHeight > 80) {
      setShowMore(true);
    }
  }, []);

  return (
    <div className="video-description-container">
      <div
        className={`video-description expanded `}
        ref={contentRef}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 7,
        }}
      >
        <span>
          <span className="bold"> タグ :</span>{" "}
          <TagVideoList tags={tags || []} />
        </span>

        <span>
          <span className="bold"> 事業所 :</span> {offices.join(", ")}
        </span>
        {/* <span>
          <span className="bold"> プレイリスト :</span> プレイリスト1
        </span> */}
        <span>
          <span className="bold"> カテゴリー :</span> {categoryName}
        </span>
        <span>
          <span className="bold"> 機器名 :</span> {Array.from(new Set(listMachine)).join(", ")}
        </span>
        <span>
          <span className="bold"> 動画説明 : </span>
          {linkifyText(description)}
        </span>
      </div>
      
    </div>
  );
};

export default VideoDescription;
